import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { keyframes, useTheme } from '@emotion/react';
import { forwardRef, useId, useImperativeHandle, useRef, useState } from 'react';
import ReactSelect from 'react-select';
import { Control } from '../../primitives/Select/components/Control/index.js';
import { DropdownIndicator } from '../../primitives/Select/components/DropdownIndicator.js';
import { Input } from '../../primitives/Select/components/Input.js';
import { MenuList } from '../../primitives/Select/components/MenuList.js';
import { Option } from '../../primitives/Select/components/Option/index.js';
import { Placeholder } from '../../primitives/Select/components/Placeholder/index.js';
import { SelectContainer } from '../../primitives/Select/components/SelectContainer.js';
import { SingleValue } from '../../primitives/Select/components/SingleValue/index.js';
import { ValueContainer } from '../../primitives/Select/components/ValueContainer/index.js';
const customStyles = {
  container: (provided, state) => {
    const highlight = keyframes`
      from {
        outline-color: ${state.theme.app.colors.backgroundPrimary};
      }
      to {
        outline-color: ${state.theme.app.colors.systemWarning};
      }
    `;
    return {
      ...provided,
      minWidth: '0',
      borderRadius: '5px',
      outline: '2px solid transparent',
      ...(state.selectProps.highlighted && {
        animation: `${highlight} 0.5s forwards`
      }),
      ...(state.selectProps.fullWidth && {
        width: '100%'
      })
    };
  },
  indicatorSeparator: () => ({
    display: 'none'
  }),
  // @ts-expect-error TS(7006) FIXME: Parameter 'provided' implicitly has an 'any' type.
  menu: (provided, state) => ({
    ...provided,
    borderRadius: '5px',
    boxShadow: '0px 0px 24px rgba(0, 0, 0, 0.08), 0px 8px 24px rgba(0, 0, 0, 0.1)',
    zIndex: state.theme.app.stacking.zIndexControlsPriority
  }),
  // @ts-expect-error TS(7006) FIXME: Parameter 'provided' implicitly has an 'any' type.
  group: (provided, state) => ({
    '& + &': {
      borderTop: `1px solid ${state.theme.app.colors.borderSecondary}`
    }
  }),
  groupHeading: () => ({
    display: 'none'
  }),
  input: provided => ({
    ...provided,
    margin: 0,
    padding: 0,
    // This is making the input element wrapper div with the inline `inline-block` style explicitly set by React Select fit correctly in our layout
    lineHeight: '1rem'
  }),
  // @ts-expect-error TS(7006) FIXME: Parameter 'provided' implicitly has an 'any' type.
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: '0',
    ...(state.isDisabled ? {
      color: state.theme.app.colors.contentStateDisabled
    } : {
      color: state.theme.app.colors.interactionSecondary,
      '&:hover': {
        color: state.theme.app.colors.interactionSecondary
      }
    })
  })
};
export const Select = /*#__PURE__*/_styled(forwardRef(function Select(props, ref) {
  const {
    styles,
    components,
    message,
    pinnedPlaceholder = false,
    invalid = false,
    highlighted: controlledHighlighted,
    size = 'medium',
    highlightBehaviour = 'onFocus',
    centered = false,
    disabled,
    customMenuListHeight,
    menuShouldScrollIntoView,
    onMenuOpen,
    id: propsId,
    controlIcon,
    dropdownIndicatorIcon,
    formatSingleValue,
    menuListProps
  } = props;
  const appTheme = useTheme();
  const selectRef = useRef();
  const [highlighted, setHighlighted] = useState(false);
  const autoId = useId();
  const id = propsId || autoId;
  const selectProps = {
    ...props,
    isPinned: pinnedPlaceholder,
    highlighted: controlledHighlighted == null ? highlighted : controlledHighlighted,
    size,
    invalid,
    message,
    highlightBehaviour,
    centered,
    controlIcon,
    dropdownIndicatorIcon,
    formatSingleValue,
    menuListProps
  };
  useImperativeHandle(ref, () => ({
    focus: () => {
      selectRef.current.focus();
    },
    highlightOn: () => {
      setHighlighted(true);
    },
    highlightOff: () => {
      setHighlighted(false);
    }
  }));
  return _jsx(ReactSelect, {
    ...selectProps,
    ref: selectRef,
    styles: {
      ...customStyles,
      menuList: provided => ({
        ...provided,
        height: customMenuListHeight
      }),
      ...styles
    },
    components: {
      Control,
      SingleValue,
      Option,
      Placeholder,
      ValueContainer,
      SelectContainer,
      DropdownIndicator,
      MenuList,
      Input,
      ...components
    },
    // Make our own theme available inside React Select styling callbacks
    theme: theme => ({
      ...theme,
      app: appTheme
    }),
    isDisabled: disabled,
    menuShouldScrollIntoView: menuShouldScrollIntoView,
    onMenuOpen: onMenuOpen,
    inputId: id
  });
}), process.env.NODE_ENV === "production" ? {
  target: "evxrh3v0"
} : {
  target: "evxrh3v0",
  label: "Select"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");